import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = {
  "clip-path": "url(#clip0_5773_118745)"
};
const _hoisted_3 = ["stroke"];
const _hoisted_4 = ["stroke"];
const _hoisted_5 = /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("clipPath", {
  id: "clip0_5773_118745"
}, [/*#__PURE__*/_createElementVNode("rect", {
  width: "10",
  height: "10",
  fill: "white"
})])], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: $props.width,
    height: $props.height,
    viewBox: "0 0 10 10",
    fill: "none"
  }, [_createElementVNode("g", _hoisted_2, [_createElementVNode("path", {
    d: "M8.75 4.79232V3.66732C8.75 2.96725 8.75 2.61722 8.61376 2.34983C8.49392 2.11463 8.30269 1.9234 8.06749 1.80356C7.8001 1.66732 7.45007 1.66732 6.75 1.66732H3.25C2.54993 1.66732 2.1999 1.66732 1.93251 1.80356C1.69731 1.9234 1.50608 2.11463 1.38624 2.34983C1.25 2.61722 1.25 2.96725 1.25 3.66732V7.16732C1.25 7.86738 1.25 8.21742 1.38624 8.48481C1.50608 8.72001 1.69731 8.91123 1.93251 9.03108C2.1999 9.16732 2.54993 9.16732 3.25 9.16732H5.20833M8.75 4.16732H1.25M6.66667 0.833984V2.50065M3.33333 0.833984V2.50065",
    stroke: $props.color,
    "stroke-width": "0.8",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, 8, _hoisted_3), _createElementVNode("path", {
    d: "M9.6665 7H4.99984M4.99984 7L6.74984 5.25M4.99984 7L6.74984 8.75",
    stroke: $props.color,
    "stroke-width": "0.8",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, 8, _hoisted_4)]), _hoisted_5], 8, _hoisted_1);
}